import { render, staticRenderFns } from "./PlotImagesForm.vue?vue&type=template&id=4de93a03&"
import script from "./PlotImagesForm.vue?vue&type=script&lang=js&"
export * from "./PlotImagesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports